var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.189,
    height: 77.837,
    viewBox: "0 0 156.189 77.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8679",
    "data-name": "Group 8679",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 7.678,
    cy: 7.678,
    r: 7.678,
    transform: "translate(34.967 48.307)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12137",
    "data-name": "Path 12137",
    d: "M351.318,519.474a7.678,7.678,0,0,0,12.793,8.126,7.678,7.678,0,1,1-12.793-8.126Z",
    transform: "translate(-314.342 -468.618)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12138",
    "data-name": "Path 12138",
    d: "M246.378,325.819h.021l.38,21.767h-.8Z",
    transform: "translate(-203.712 -269.835)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 15.479,
    cy: 15.479,
    r: 15.479,
    transform: "translate(11.632 18.386)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12139",
    "data-name": "Path 12139",
    d: "M217.857,360.416A15.481,15.481,0,0,0,243.65,376.8a15.481,15.481,0,1,1-25.793-16.383Z",
    transform: "translate(-202.176 -336.89)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12140",
    "data-name": "Path 12140",
    d: "M154.135,197.087h.043l.765,43.886h-1.616Z",
    transform: "translate(-126.982 -163.222)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17539",
    "data-name": "Rectangle 17539",
    width: 70.95,
    height: 21.033,
    transform: "translate(58.216 55.036)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17540",
    "data-name": "Rectangle 17540",
    width: 8.273,
    height: 16.686,
    transform: "translate(89.554 59.383)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17541",
    "data-name": "Rectangle 17541",
    width: 62.677,
    height: 19.35,
    transform: "translate(62.352 30.217)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12141",
    "data-name": "Path 12141",
    d: "M543.746,254.909H468.36a.631.631,0,0,1-.437-1.086l20.6-19.8v-8.626a.632.632,0,0,1,.631-.631h4.066a.632.632,0,0,1,.631.631v3.5l1.556-1.5a13.982,13.982,0,0,1,19.038-.317l29.72,26.723a.631.631,0,0,1-.422,1.1Z",
    transform: "translate(-412.362 -223.5)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12142",
    "data-name": "Path 12142",
    d: "M439.915,204.421h0a4,4,0,0,1,4,4v5.4h-7.992v-5.4A4,4,0,0,1,439.915,204.421Z",
    transform: "translate(-361.017 -169.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12143",
    "data-name": "Path 12143",
    d: "M526.008,204.829h0a4,4,0,0,1,4,4v5.4h-7.992v-5.4A4,4,0,0,1,526.008,204.829Z",
    transform: "translate(-432.317 -169.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12144",
    "data-name": "Path 12144",
    d: "M612.1,205.237h0a4,4,0,0,1,4,4v5.4h-7.992v-5.4A4,4,0,0,1,612.1,205.237Z",
    transform: "translate(-503.618 -169.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12145",
    "data-name": "Path 12145",
    d: "M646.376,344.373h0a4,4,0,0,1,4,4v5.4H642.38v-5.4A4,4,0,0,1,646.376,344.373Z",
    transform: "translate(-532.003 -285.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12146",
    "data-name": "Path 12146",
    d: "M416.25,344.373h0a4,4,0,0,1,4,4v5.4h-7.992v-5.4A4,4,0,0,1,416.25,344.373Z",
    transform: "translate(-341.418 -285.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12147",
    "data-name": "Path 12147",
    d: "M514.054,517.095l-13.31-5.889a.561.561,0,0,0-.227-.048H437.087a.561.561,0,0,0-.211.041l-14.487,5.889a.561.561,0,0,0,.211,1.08h3.759v19.35h-.421v1.963h84.551v-1.963h-.7v-19.35h4.039a.561.561,0,0,0,.227-1.074Zm-5.388,20.424H427.48v-19.35h81.186Z",
    transform: "translate(-374.523 -461.731)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17542",
    "data-name": "Rectangle 17542",
    width: 10.236,
    height: 1.683,
    transform: "translate(73.64 43.748)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17543",
    "data-name": "Rectangle 17543",
    width: 10.236,
    height: 1.683,
    transform: "translate(88.643 43.748)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17544",
    "data-name": "Rectangle 17544",
    width: 10.236,
    height: 1.683,
    transform: "translate(103.646 43.748)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17545",
    "data-name": "Rectangle 17545",
    width: 10.236,
    height: 1.683,
    transform: "translate(109.255 68.006)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17546",
    "data-name": "Rectangle 17546",
    width: 10.236,
    height: 1.683,
    transform: "translate(69.573 68.006)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12148",
    "data-name": "Path 12148",
    d: "M301.517,674.844H145.672a.172.172,0,1,1,0-.344H301.517a.172.172,0,1,1,0,.344Z",
    transform: "translate(-145.5 -597.007)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12149",
    "data-name": "Path 12149",
    d: "M646.4,385.249c0,.11,0,.222,0,.332,0,.132-.005.263-.01.4-.005.115-.01.228-.017.342-.021.38-.053.758-.1,1.138-.01.1-.022.191-.036.287-.01.074-.021.15-.033.225s-.024.168-.038.253q-.041.268-.093.536c-.017.089-.034.179-.053.268-.036.177-.076.356-.117.533l-.01.043c-.021.088-.041.173-.064.261-.007.026-.012.05-.021.076-.015.065-.033.131-.05.2-.024.091-.048.18-.074.271-.041.141-.082.28-.125.421a.46.46,0,0,0-.014.045c-.083.266-.17.529-.266.79-.05.137-.1.277-.156.414s-.108.275-.165.411-.112.265-.168.4c-.014.031-.028.062-.043.093-.06.136-.122.268-.186.4,0,0,0,.005,0,.007-.05.107-.1.213-.156.318a.013.013,0,0,1,0,.009c-.052.1-.1.206-.16.308l-.088.167-.01.019c-.11.2-.223.407-.344.608-.026.045-.051.089-.077.132s-.053.089-.081.132-.036.062-.057.093c-.036.058-.072.119-.11.177l-.022.036-.2.3c-.081.122-.163.242-.247.363l-1.866,2.986-.081-.067-.022-.021h0l-.074-.062-.2-.172c-.062.06-.122.12-.184.179l-.074.07-.055.052a17.993,17.993,0,0,1-12.024,5.112h-.005a19.638,19.638,0,0,1-9.8-2.313c-.067-.034-.132-.069-.2-.108-.392-.213-.775-.438-1.151-.679l-.005,0q-.655-.464-1.278-.99a18.888,18.888,0,0,1-6.689-15.428c.005-.115.012-.229.021-.344q.041-.624.127-1.242c.015-.115.033-.23.05-.344h36.733q.108.789.15,1.586C646.389,384.587,646.4,384.917,646.4,385.249Z",
    transform: "translate(-529.579 -355.32)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12150",
    "data-name": "Path 12150",
    d: "M646.446,306.464a18.573,18.573,0,0,0-36.733,0c-.017.113-.034.228-.05.344q-.085.619-.127,1.242H646.6Q646.554,307.254,646.446,306.464Z",
    transform: "translate(-529.803 -279.114)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12151",
    "data-name": "Path 12151",
    d: "M673.164,433.519H662.521v-8.513c.2-3.891,3.522-4.2,6.646-4a4,4,0,0,1,4,4Z",
    transform: "translate(-573.684 -387.032)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12152",
    "data-name": "Path 12152",
    d: "M618.416,318.623v0s0,0,0,0Zm-4.28-13.084c-.007.043-.015.086-.022.129.007-.043.015-.086.024-.129Zm-.213,1.586c-.005.065-.01.131-.014.2q.005-.1.016-.2a.247.247,0,0,1,0-.036C613.924,307.1,613.924,307.113,613.922,307.125Zm4.493,11.5s0,0,0,0l0,0Zm-4.28-13.086c-.007.043-.015.086-.022.129.007-.043.015-.086.024-.129Zm-.227,1.782q.005-.1.016-.2a.247.247,0,0,1,0-.036c0,.012,0,.024,0,.036C613.917,307.19,613.912,307.255,613.909,307.321Zm53.084,31.609a1.175,1.175,0,0,0-.107-.1l0,0-8.509-7.181-.22-.186-.837-.706-.21-.177-1.192-1.007-.326-.275-.675-.57-.345-.292-3.258-2.747-1.868-1.576-.251-.211-5.5-4.644c.084-.12.167-.241.247-.363l.2-.3.022-.036c.038-.058.074-.118.11-.177q.031-.046.057-.093c.028-.043.055-.088.081-.132s.052-.088.077-.132c.12-.2.234-.4.344-.608l.01-.019.088-.167c.055-.1.108-.2.16-.308a.013.013,0,0,0,0-.009c.053-.1.107-.211.156-.318,0,0,0-.005,0-.007.063-.132.125-.265.185-.4.015-.031.029-.062.043-.093.057-.131.113-.263.168-.4s.112-.273.165-.411.107-.277.156-.414q.142-.394.266-.79a.4.4,0,0,1,.014-.045c.043-.141.084-.28.125-.421.026-.091.05-.18.074-.271.017-.065.034-.131.05-.2.009-.026.014-.05.021-.076.022-.088.043-.174.064-.261l.01-.043c.041-.177.081-.356.117-.533.019-.089.036-.179.053-.268.033-.179.065-.357.093-.536.014-.084.026-.168.038-.253s.022-.151.033-.225c.014-.1.026-.191.036-.287.045-.38.077-.758.1-1.137.007-.113.012-.227.017-.342.005-.132.009-.263.01-.4,0-.11,0-.222,0-.332,0-.332-.009-.662-.026-.993q-.041-.8-.15-1.586a18.91,18.91,0,0,0-37.42-.344c-.017.113-.034.229-.05.344q-.085.619-.127,1.242c-.009.115-.015.229-.021.344a18.888,18.888,0,0,0,6.689,15.428q.624.526,1.278.99l.005,0c.146.1.292.2.44.3.235.155.473.306.711.45l.057.033c.206.124.414.242.622.357h0a18.6,18.6,0,0,0,2.4,1.107,18.966,18.966,0,0,0,7.6,1.192h.005a18.859,18.859,0,0,0,8.576-2.538c.38-.22.754-.455,1.12-.706.091-.062.184-.126.273-.189.11-.077.22-.158.33-.239l0,0,.026-.019.222-.168c.019-.014.038-.028.057-.043l.014-.012c.043-.031.084-.065.127-.1s.084-.067.127-.1L640,323.2l.144-.117c.05-.039.1-.081.144-.12s.094-.079.143-.12.084-.07.125-.108c.014-.01.026-.022.039-.034l.017-.014c.057-.048.112-.1.167-.148l.039-.036c.084-.076.168-.151.251-.23l.058-.053.055-.052c.024-.024.05-.046.074-.07.062-.058.122-.119.184-.179l.2.172.074.062h0l.022.021.081.067,1.2,1.014.026.022.021.015.136.115.271.23.272.229.039.033,1.263,1.065.175.148,1.218,1.028,6.306,5.321.22.186,8.631,7.282,2.213,1.868.823.694a1.741,1.741,0,0,0,2.455-.206,1.69,1.69,0,0,0,.29-.488A1.734,1.734,0,0,0,666.992,338.93ZM617.22,299.1a14.166,14.166,0,0,1,24.734,6.44c.022.115.043.229.062.344.07.411.122.826.153,1.242.009.115.017.229.022.344.016.258.022.517.022.775a14.107,14.107,0,0,1-.766,4.595v0a14.091,14.091,0,0,1-2.572,4.533c-.024.028-.048.057-.074.084-.227.268-.466.526-.711.771l-.005.007c-.084.084-.17.17-.256.249-.175.17-.354.332-.536.486q-.41.358-.84.672c-.1.07-.192.139-.29.208s-.194.134-.292.2c-.2.131-.4.256-.6.375-.1.06-.2.118-.3.175s-.2.113-.308.167-.206.108-.311.16c-.208.1-.418.2-.631.294q-.16.072-.32.134c-.067.027-.132.055-.2.079a.637.637,0,0,1-.081.031q-.054.023-.108.041l-.036.014c-.074.029-.146.055-.222.081-.108.039-.217.076-.326.11s-.218.07-.328.1-.222.065-.332.095-.222.06-.333.086-.237.058-.357.084c-.1.024-.208.045-.313.064s-.2.038-.3.055c-.138.024-.275.046-.414.065-.076.012-.15.022-.225.029-.033.005-.064.009-.094.012-.1.014-.193.024-.287.033l-.074.007c-.1.01-.211.019-.316.027-.225.015-.448.026-.674.031-.113,0-.228,0-.342,0s-.227,0-.34-.005c0,0,0,0,0,0s0,0,0,0h0a.03.03,0,0,1-.017,0c-.081,0-.162,0-.241-.009-.058,0-.119,0-.179-.009q-.121-.005-.242-.016c-.026,0-.052,0-.077-.005l-.036,0c-.082-.007-.167-.014-.249-.022-.041,0-.084-.007-.125-.012-.125-.014-.251-.029-.375-.046-.141-.017-.282-.038-.421-.064-.065-.009-.129-.021-.192-.033q-.126-.021-.253-.046c-.088-.017-.175-.034-.263-.055-.07-.015-.143-.031-.213-.048-.034-.007-.069-.015-.1-.024-.18-.043-.359-.089-.536-.141-.112-.031-.223-.064-.333-.1-.151-.046-.3-.1-.45-.15-.058-.019-.115-.039-.174-.062s-.115-.041-.173-.064-.107-.04-.158-.06c-.086-.033-.17-.067-.254-.1-.174-.07-.344-.144-.514-.223-.1-.046-.192-.091-.287-.137q-.559-.271-1.1-.6c-.089-.053-.179-.11-.268-.167-.112-.069-.22-.141-.328-.213l-.177-.122c-.108-.076-.215-.153-.32-.23-.055-.039-.11-.081-.163-.122-.191-.144-.378-.3-.562-.45-.088-.074-.175-.149-.261-.227-.036-.031-.072-.064-.108-.1s-.083-.074-.122-.113l0,0c-.06-.053-.12-.11-.179-.167-.091-.086-.18-.174-.266-.263s-.175-.179-.259-.268-.168-.18-.249-.273-.163-.184-.242-.278-.153-.182-.225-.273q-.263-.325-.5-.661c-.074-.1-.144-.206-.213-.311s-.144-.215-.211-.323-.138-.218-.2-.33a.037.037,0,0,0-.007-.01c-.129-.218-.253-.438-.368-.661s-.23-.456-.335-.687c-.053-.115-.1-.232-.153-.349-.1-.235-.192-.471-.278-.71-.043-.115-.083-.23-.122-.347a.087.087,0,0,0-.007-.022c-.079-.237-.151-.476-.215-.717,0,0,0-.007,0-.01-.033-.119-.064-.237-.091-.357-.027-.1-.052-.21-.074-.316s-.052-.237-.074-.357c-.012-.062-.024-.124-.034-.186s-.019-.1-.028-.156-.017-.1-.026-.158q-.026-.157-.047-.314c-.017-.124-.031-.247-.045-.373-.015-.149-.029-.3-.041-.45-.009-.1-.014-.2-.019-.308s-.01-.189-.012-.284a.026.026,0,0,1,0-.015v0s0,0,0,0v0c0-.038,0-.076,0-.113q-.005-.168-.005-.335c0-.1,0-.2,0-.3q.005-.211.016-.423c0-.031,0-.06.005-.091s0-.06.005-.091q.005-.1.016-.2a.265.265,0,0,1,0-.036c.005-.074.012-.148.019-.222.014-.148.031-.3.05-.445.01-.074.019-.148.031-.222.007-.052.016-.1.024-.158s.015-.107.026-.16c.012-.07.024-.143.038-.215.007-.043.016-.086.024-.129q.049-.258.108-.515c.039-.174.084-.345.132-.517s.1-.347.153-.521c.026-.088.053-.174.084-.259.057-.173.117-.345.184-.515.031-.084.064-.17.1-.254.069-.17.141-.34.215-.507.038-.084.076-.168.117-.253.077-.167.158-.333.246-.5s.175-.33.268-.491.189-.323.29-.483c.046-.079.1-.16.151-.237.1-.158.211-.316.321-.471C616.728,299.705,616.967,299.4,617.22,299.1Zm-3.3,8.026c-.005.065-.01.131-.014.2q.005-.1.016-.2a.247.247,0,0,1,0-.036C613.924,307.1,613.924,307.113,613.922,307.125Zm.213-1.586c-.007.043-.015.086-.022.129.007-.043.015-.086.024-.129Zm4.28,13.084v0s0,0,0,0Z",
    transform: "translate(-529.579 -278.189)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12153",
    "data-name": "Path 12153",
    d: "M633.927,369.584a14.168,14.168,0,0,1-2.4-19.045q-.406.409-.786.857a14.167,14.167,0,1,0,21.655,18.272q.378-.449.713-.919A14.168,14.168,0,0,1,633.927,369.584Z",
    transform: "translate(-544.595 -328.71)",
    opacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.dc358f82611ac8dd0b7c8e8b761a7535.svg";
export { ForwardRef as ReactComponent };